import React, {useEffect, useContext} from "react";
import { useParams, useNavigate  } from "react-router-dom";
import { AppContext } from "../../utils/AppContext";

const FeaturePage = () => {
    const appContext = useContext(AppContext);
    const params = useParams();
    const navigate = useNavigate(); // Use the useNavigate hook for programmatic navigation

    useEffect(() => {
        // Delay the redirect by 1 second (1000 milliseconds)
        setTimeout(() => {
            if (params.feature_name === "games") {
                window.location.href = "https://games.woilo.com"; // Redirect to external URL
            } else {
                window.location.href = "https://woilo.com"; // Redirect to external URL
            }
        }, 1000); // 1000 ms delay

    }, [params.feature_name]);

    return(
        <>
            <div>
                Redirect...
            </div>
        </>
    )
}

export default FeaturePage;